import { EdlTooltipConfig } from '@edl-development/edl-common';

// The header's own job is sorting, and Enter and Space have to keep doing that. Left to its
// default the tooltip would swallow both keys to open and close itself instead.
/** How a sort header's explanation behaves, for a control that already answers to Enter and Space. */
export const SORT_BY_TOOLTIP_CONFIG: EdlTooltipConfig = { shouldTriggerOnKeydown: false };
